import { FileUpload } from '../components/FileUpload.jsx';

export function Documents({ onNext, onBack }) {
  return (
    <div className="space-y-6">
      <header>
        <h2 className="text-xl font-semibold text-brand-900">Documents</h2>
        <p className="text-sm text-slate-500">
          Upload any business documents you have. All uploads are optional, but bank statements
          help speed up underwriting. Accepted: PDF, Word, photos (JPG/PNG/HEIC), CSV. Max 25 MB each.
        </p>
      </header>

      <FileUpload category="bank_statement"  label="Last 4 months of business bank statements (recommended)" />
      <FileUpload category="voided_check"    label="Voided check (optional)" />
      <FileUpload category="drivers_license" label="Driver's license (optional)" />
      <FileUpload category="other"           label="Anything else (optional)" />

      <div className="flex justify-between">
        <button className="btn-ghost" onClick={onBack}>Back</button>
        <button className="btn-primary" onClick={onNext}>Continue</button>
      </div>
    </div>
  );
}
